import React, { useEffect, useState } from 'react';
import {AiOutlineCheck, AiOutlineClose, AiOutlineCoffee} from 'react-icons/ai'
import { Chart } from 'react-charts'

function Result({c, votes, type, showVotes, cards}) {

  const [media, setMedia] = useState(0);
  const [mediana, setMediana] = useState(0);
  const [desvioPadrao, setDesvioPadrao] = useState(0);
  const [variancia, setVariancia] = useState(0);

  const data = React.useMemo(
    () => {
      if (type === 1) {
        var data = [...(cards.map(card => [card, 0])), ["Coffee Break",0]];
        votes.map(vote => {
          var dtIndex = null;
          data.map((item, index) => {
            if (item[0] == vote.value.poker) {

              dtIndex = index;
            }
          });

          if (vote.coffee) {
            data[data.length-1][1] += 1
          }
          
          if (dtIndex !== null) {
            data[dtIndex] = [data[dtIndex][0], data[dtIndex][1] + 1]
          }

        })
        return [
          {
            data: data,
            label: 'Poker',
            dataType: 'ordinal',
          },
        ]
      }
      else if (type === 2) {
        var data = [[1,1,0], [2,1,0], [3,1,0], [4,1,0], [5,1,0], [1,1,0], [1,2,0], [1,3,0], [1,4,0], [1,5,0]];
        votes.map(vote => {
          var dtIndex = null;
          data.map((item, index) => {
            if (item[0] == vote.value.complexity && item[1] == vote.value.effort) {
              dtIndex = index;
            }
          });
  
          if (dtIndex) {
            data[dtIndex] = [data[dtIndex][0], data[dtIndex][1], data[dtIndex][2] + 1]
          }
          else {
            data.push([vote.value.complexity, vote.value.effort, 1]);
          }
        })
        return [
          {
            data: data,
            label: 'Complexity X Effort',
            dataType: 'log',
            series: 10,
            useR: true,
          },
        ]
      }
  
  },
    [votes]
  )

 
  const series = React.useMemo(
    () => {
      if (type === 1) {
        return ({
          type: 'bar'
        })
      }
      else if (type === 2) {
        return ({
          type: 'bubble',
          showPoints: false,
          invert: true,
          
        })
      }
    },
    []
  )
  const axes = React.useMemo(
    () => {
      if (type === 1) {
        return [
          { primary: true, type: 'ordinal', position: 'bottom' },
          { position: 'left', type: 'linear', stacked: false }
        ]
      }
      else if (type === 2) {
        return [
          { primary: true, type: 'linear', position: 'bottom'},
          { type: 'linear', position: 'left' }
        ]
      }
    },
    []
  )

  useEffect(() => {
    if (!votes) {
      return;
    }
    var vts = votes.filter(vote => {
      return vote.value.poker != "Infinite";
    })
    if (vts && vts.length > 0) {
      var sum = 0;
      vts.forEach(vote => {
        if (vote.value.poker) {
          sum += vote.value.poker
        }
      })
      var med = sum / vts.length
      var vari = 0
      vts.forEach(vote => {
        if (vote.value.poker) {
          vari += (vote.value.poker - med) ** 2
        }
      })
      if (vts.length - 1 != 0) {
        vari = vari / (vts.length - 1)
      }

      var sorted = vts.sort((a,b) => a.value.poker-b.value.poker)

      var medidx = Math.ceil((vts.length-1)/2)
      var mediananums = [sorted[medidx].value.poker]
      if (vts.length % 2 === 0) {
        if (sorted[medidx+1]) {
          mediananums.push(sorted[medidx+1].value.poker)
        }
      }
      var medb = 0
      mediananums.forEach(item => {
        medb += item
      })
      medb /= mediananums.length

      var dp = Math.sqrt(vari)

      setMedia(med)
      setMediana(medb)
      setVariancia(vari)
      setDesvioPadrao(dp)
    }
    else {
      setMedia(0)
      setMediana(0)
      setVariancia(0)
      setDesvioPadrao(0)
    }
  }, [votes])
 

  return (
  <>{!showVotes ? 
    <span style={{color: 'rgba(0,0,0,0.4)'}}>The admin didn't set the votes to visible yet...</span>
    :
    <>
    <div className={c.chart}>
        <Chart
          data={data}
          series={series}
          axes={axes}
          grouping="single"
          tooltip
        />
    </div>
    <div style={{height: 20}}></div>
    <h2>Votes</h2>
    <br/>
    {type === 1 && (
      <>
        <p style={{marginBottom: 10}}>Average: {media.toFixed(1)}</p>
        <p style={{marginBottom: 10}}>Median: {mediana.toFixed(1)}</p>
        <p style={{marginBottom: 10}}>Variance: {variancia.toFixed(1)}</p>
        <p style={{marginBottom: 10}}>Standard deviation: {desvioPadrao.toFixed(1)}</p>
      </>
    )}
    

    <div className={c.voteResultCards}>
      {votes.map((vote, index) => {
        return (
          <div key={"room-votes-"+index} className={c.voteResultCard}>
              <span>{vote.user}</span>
              -
              {type === 1 ? 
                <span>
                  {vote.value.poker} 
                  {vote.coffee && <AiOutlineCoffee style={{marginLeft: 5}}></AiOutlineCoffee>}
                </span>
              :
                <span>
                  {vote.value.complexity}x{vote.value.effort}
                  {vote.coffee && <AiOutlineCoffee style={{marginLeft: 5}}></AiOutlineCoffee>}
                </span>
              }
          </div>
        )
      })}
      {votes.length === 0 && <span style={{color: 'rgba(0,0,0,0.4)'}}>No members have voted yet ...</span>}
    </div>
    </>
    }

  </>
  );
}

export default Result;